export enum PushTopic {
  NewItems = 'newItems',
  NewStores = 'newStores',
  Tips = 'tips',
}
